import { AreaChart, Area, YAxis, ResponsiveContainer } from 'recharts';

const equityData = [
  { value: 10000 }, { value: 10200 }, { value: 10500 }, { value: 10900 },
  { value: 11200 }, { value: 11600 }, { value: 12200 }, { value: 12800 },
  { value: 13300 }, { value: 13900 }, { value: 14500 }, { value: 15000 },
  { value: 15600 }, { value: 16200 }, { value: 16700 }, { value: 17100 },
  { value: 17400 }, { value: 17600 }, { value: 17800 }, { value: 17700 },
];

export default function PerformanceMetricsModalMock() {
  const sectionHeader: React.CSSProperties = {
    fontSize: '0.5rem',
    fontWeight: 700,
    color: '#6b7280',
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
    marginBottom: '0.375rem',
  };

  const metricRow: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    padding: '0.125rem 0',
    fontSize: '0.6875rem',
  };

  return (
    <div className="platform-mock" style={{ maxWidth: '100%' }}>
      <div className="platform-mock-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span><span className="dot" style={{ background: '#22c55e' }} /> Performance Metrics</span>
        <span style={{ fontSize: '0.75rem', color: '#4b5563', cursor: 'default' }}>x</span>
      </div>
      <div className="platform-mock-body" style={{ padding: '0.75rem 1rem' }}>
        {/* Subtitle bar */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: '0.75rem' }}>
          <span style={{ fontSize: '0.6875rem', color: '#9ca3af' }}>Historical simulation outcomes from 62 trades</span>
          <span style={{ fontSize: '0.5625rem', color: '#ef4444', fontStyle: 'italic' }}>Past performance does not predict future results</span>
        </div>

        {/* 2x2 grid */}
        <div style={{ display: 'grid', gridTemplateColumns: '1.2fr 0.8fr', gap: '0.5rem' }}>
          {/* Panel 1: Equity Path */}
          <div style={{ background: '#0f1a28', borderRadius: 6, padding: '0.625rem 0.75rem', border: '1px solid #1f2937' }}>
            <div style={sectionHeader}>Equity Path (Historical Simulation)</div>
            <ResponsiveContainer width="100%" height={70}>
              <AreaChart data={equityData} margin={{ top: 4, right: 4, bottom: 0, left: 0 }}>
                <defs>
                  <linearGradient id="eq-grad" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#6366f1" stopOpacity={0.3} />
                    <stop offset="100%" stopColor="#6366f1" stopOpacity={0.02} />
                  </linearGradient>
                </defs>
                <YAxis domain={['dataMin', 'dataMax']} hide />
                <Area
                  type="monotone"
                  dataKey="value"
                  stroke="#818cf8"
                  strokeWidth={1.5}
                  fill="url(#eq-grad)"
                  isAnimationActive={false}
                />
              </AreaChart>
            </ResponsiveContainer>
            <div style={{ fontSize: '0.5rem', color: '#4b5563', fontStyle: 'italic', marginTop: 2 }}>
              Shape illustrates return concentration and recovery behaviour
            </div>
          </div>

          {/* Panel 2: Outcome Summary */}
          <div style={{ background: '#0f1a28', borderRadius: 6, padding: '0.625rem 0.75rem', border: '1px solid #1f2937' }}>
            <div style={sectionHeader}>Outcome Summary</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.375rem' }}>
              <div style={metricRow}>
                <span style={{ color: '#9ca3af' }}>Total Return</span>
                <span style={{ fontWeight: 700, color: '#e5e7eb', fontFamily: 'monospace' }}>77.01%</span>
              </div>
              <div style={metricRow}>
                <span style={{ color: '#9ca3af' }}>Net P/L</span>
                <span style={{ fontWeight: 700, color: '#e5e7eb', fontFamily: 'monospace' }}>USDT7,700.79</span>
              </div>
              <div style={metricRow}>
                <span style={{ color: '#9ca3af' }}>Trades</span>
                <span style={{ fontWeight: 700, color: '#e5e7eb', fontFamily: 'monospace' }}>62</span>
              </div>
              <div style={metricRow}>
                <span style={{ color: '#9ca3af' }}>Win Rate</span>
                <span style={{ fontWeight: 700, color: '#e5e7eb', fontFamily: 'monospace' }}>44% <span style={{ color: '#6b7280', fontSize: '0.5625rem' }}>(27W / 35L)</span></span>
              </div>
            </div>
          </div>

          {/* Panel 3: Risk-Adjusted Metrics */}
          <div style={{ background: '#0f1a28', borderRadius: 6, padding: '0.625rem 0.75rem', border: '1px solid #1f2937' }}>
            <div style={sectionHeader}>Risk-Adjusted Metrics</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
              <div style={metricRow}>
                <span style={{ color: '#9ca3af' }}>Sharpe Ratio</span>
                <span style={{ fontWeight: 700, color: '#22c55e', fontFamily: 'monospace' }}>1.49</span>
              </div>
              <div style={metricRow}>
                <span style={{ color: '#9ca3af' }}>Profit Factor</span>
                <span style={{ fontWeight: 700, color: '#e5e7eb', fontFamily: 'monospace' }}>1.52</span>
              </div>
              <div style={metricRow}>
                <span style={{ color: '#9ca3af' }}>Expectancy</span>
                <span style={{ fontWeight: 700, color: '#e5e7eb', fontFamily: 'monospace' }}>USDT124.21</span>
              </div>
              <div style={metricRow}>
                <span style={{ color: '#9ca3af' }}>Payoff Ratio</span>
                <span style={{ fontWeight: 700, color: '#e5e7eb', fontFamily: 'monospace' }}>1.97</span>
              </div>
            </div>
            <div style={{ fontSize: '0.5rem', color: '#4b5563', fontStyle: 'italic', marginTop: '0.375rem' }}>
              Returns show reasonable risk-adjusted consistency
            </div>
          </div>

          {/* Panel 4: Metric Interpretation */}
          <div style={{ background: '#0f1a28', borderRadius: 6, padding: '0.625rem 0.75rem', border: '1px solid #1f2937' }}>
            <div style={sectionHeader}>Metric Interpretation</div>
            <div style={{ marginBottom: '0.5rem' }}>
              <div style={{ fontSize: '0.5rem', fontWeight: 700, color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 2 }}>Characteristics</div>
              <div style={{ fontSize: '0.625rem', color: '#9ca3af', lineHeight: 1.5 }}>
                Low win rate compensated by larger winners<br />
                Strong risk-adjusted performance
              </div>
            </div>
            <div>
              <div style={{ fontSize: '0.5rem', fontWeight: 700, color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 2 }}>Implications</div>
              <div style={{ fontSize: '0.625rem', color: '#9ca3af', lineHeight: 1.5 }}>
                Metrics alone overstate reliability<br />
                Verify with out-of-sample or walk-forward testing
              </div>
            </div>
          </div>
        </div>

        {/* Raw Metrics (collapsed) */}
        <div style={{ marginTop: '0.5rem', background: '#0f1a28', borderRadius: 6, padding: '0.5rem 0.75rem', border: '1px solid #1f2937' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{ fontSize: '0.625rem', fontWeight: 600, color: '#9ca3af' }}>Raw Metrics</span>
            <span style={{ fontSize: '0.5rem', color: '#4b5563' }}>v</span>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)', gap: '0.25rem', marginTop: '0.375rem' }}>
            {[
              ['Return %', '77.01%'],
              ['Net P/L', 'USDT7,700.79'],
              ['Win Rate', '43.5%'],
              ['Sharpe', '1.49'],
              ['Profit Factor', '1.52'],
              ['Expectancy', 'USDT124.21'],
            ].map(([label, value], i) => (
              <div key={i}>
                <div style={{ fontSize: '0.4375rem', color: '#4b5563' }}>{label}</div>
                <div style={{ fontSize: '0.5625rem', fontWeight: 700, color: '#e5e7eb', fontFamily: 'monospace' }}>{value}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="platform-mock-caption">
        The Performance Metrics modal — a 2x2 analytical layout with equity path, outcome summary, risk-adjusted metrics, and automated interpretation.
      </div>
    </div>
  );
}
